<script setup>
/**
 * The advice follows what the step now asks. It used to talk about combining
 * four teaching methods, which is not a choice an applicant is offered any more.
 */
const tips = [
  'Offering both reaches students who want a class and students who want a tutor',
  'Bindle Live has not launched — picking it now only registers your interest',
  'Your study material comes with either, so publish it once and it counts twice'
]
</script>

<template>
  <section id="tips-section" class="bg-gradient-to-br from-teal-500 to-teal-800 rounded-2xl p-6 text-white mb-6">
    <div class="flex items-start space-x-3 mb-4">
      <span class="material-symbols-outlined text-yellow-300 text-xl">lightbulb</span>
      <h4 class="text-lg font-bold">Pro Tips</h4>
    </div>
    <ul class="space-y-3 text-sm">
      <li v-for="(tip, index) in tips" :key="index" class="flex items-start space-x-2">
        <span class="material-symbols-outlined text-green-300 mt-0.5 text-base">check</span>
        <span>{{ tip }}</span>
      </li>
    </ul>
  </section>
</template>
